import _urlParams from './url-params';
import _PrizeDecoder from './prize-decoder';
import _copy from './copy';
import _windowOpen from './window-open';
import is from './is';
export const urlParams = _urlParams;
export const PrizeDecoder = _PrizeDecoder;
export const copy = _copy;
export const windowOpen = _windowOpen;
export const isObject = is.isObject;
export const isString = is.isString;
export const isArray = is.isArray;
export const isNull = is.isNull;
export const isBoolean = is.isBoolean;
export const isUndefined = is.isUndefined;
export const isFunction = is.isFunction;
export const isNumber = is.isNumber;
/**
 * 匹配是否是当日
 * @param {*} time - 需要匹配的时间戳
 * @param {*} serverTime - 服务器的时间戳，如果不传，则取本地的时间，不建议使用前端本地时间进行比较！
 */
export const matchToday = (time, serverTime = new Date()) => {
    const now = new Date(serverTime);
    const match = new Date(time);
    return (now.getFullYear() === match.getFullYear())
        && (now.getMonth() === match.getMonth())
        && (now.getDate() === match.getDate());
};
/**
 * 日期加减对应天数
 * @param {Number} timestamp 时间戳
 * @param {Number} num       增加的天数
 */
export const dateFormat = (timestamp, num) => {
    return timestamp.setDate(timestamp.getDate() + num);
};
const _default = {
    isObject,
    isString,
    isArray,
    isNull,
    isBoolean,
    isUndefined,
    isFunction,
    isNumber,
    urlParams,
    PrizeDecoder,
    copy,
    windowOpen,
    matchToday,
    dateFormat
};
export default _default;
